import { useCallback, useSyncExternalStore } from 'react';

/**
 * Media query đang khớp hay không, tự cập nhật khi đổi cỡ cửa sổ.
 *
 * Dùng khi phải quyết **có dựng** một phần tử theo bề rộng màn, không chỉ ẩn nó: `Modal` của antd dựng
 * mask qua portal, nên `className="xl:hidden"` chỉ ẩn hộp còn mask vẫn phủ kín màn và chặn mọi thao tác.
 *
 * ⚠️ Truyền đúng mốc Tailwind (`xl` = 1280px), đừng lấy `Grid.useBreakpoint` của antd — `xl` của antd là
 * 1200px, lệch với class `xl:` đang ẩn/hiện cột.
 */
export function useKhopManHinh(query: string): boolean {
  const dangKy = useCallback(
    (bao: () => void) => {
      const media = window.matchMedia(query);
      media.addEventListener('change', bao);
      return () => media.removeEventListener('change', bao);
    },
    [query],
  );
  return useSyncExternalStore(dangKy, () => window.matchMedia(query).matches, () => false);
}
